import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const VariantsField = ({ variants, onChange }) => (
  <div className="space-y-2">
    <Label>Variasi (mis. Warna, Ukuran, Material) — pisahkan pilihan dengan koma</Label>
    {variants.map((v, i) => (
      <div key={i} className="flex gap-2">
        <Input className="w-32" placeholder="Warna" value={v.name} data-testid={`variant-name-${i}`} onChange={(e) => onChange(variants.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))} />
        <Input placeholder="Merah, Biru, Hijau" value={v.raw ?? v.options.join(", ")} data-testid={`variant-options-${i}`}
          onChange={(e) => onChange(variants.map((x, j) => (j === i ? { ...x, raw: e.target.value } : x)))} />
        <Button type="button" variant="ghost" size="icon" onClick={() => onChange(variants.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></Button>
      </div>
    ))}
    <Button type="button" variant="outline" size="sm" data-testid="add-variant-button" onClick={() => onChange([...variants, { name: "", options: [], raw: "" }])}><Plus className="mr-1 h-4 w-4" /> Tambah variasi</Button>
  </div>
);

export const cleanVariants = (variants) => variants
  .map((v) => ({ name: v.name.trim(), options: (v.raw ?? v.options.join(",")).split(",").map((s) => s.trim()).filter(Boolean) }))
  .filter((v) => v.name && v.options.length);
